import Component from 'flarum/common/Component';

import AnnouncementManagementUpdateModal from './modal/AnnouncementManagementUpdateModal';
import AnnouncementManagementRefreshModal from './modal/AnnouncementManagementRefreshModal';
import AnnouncementManagementAddModal from "./modal/AnnouncementManagementAddModal";
import playVideoModal from "./modal/playVideoModal";
import getDaysDifferent from "../common/util/getDaysDifferent";

export default class AnnouncementListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.announcementData = this.attrs.announcementData;
  }

  view() {
    const announcementData = this.announcementData;
    const announcementID = announcementData.id();
    const announcementText = announcementData.text();
    const bilibiliLink = announcementData.bilibiliLink();
    const announcementAssignedAt = announcementData.assignedAt();
    const announcementStatus = parseInt(announcementData.status());
    const daysDifferents = getDaysDifferent(new Date().toISOString(),announcementAssignedAt);
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    return (
      <div className="u2diMapSideBarInfoData u2diInfoItemContainer">
        <div style={"overflow-wrap: break-word;"+(bilibiliLink?"cursor:pointer":"")} onclick={()=>{if(bilibiliLink){app.modal.show(playVideoModal,{link:bilibiliLink})}}}>
          {bilibiliLink && (
            <i style="margin-right: 5px;color: #00A1D6;" class="fas fa-play-circle"></i>
          )}
          {daysDifferents<=3 && (
            <span style="color: rgb(163, 0, 20);margin-right: 8px;font-size: 12px;">NEW</span>
          )}
          {announcementText}
        </div>

        {announcementStatus===0 && u2diUserType9===true && (
          <div style="text-align: right;padding-top: 5px;">
            <span style="color:blue;cursor:pointer;font-size: 14px;padding: 0px 7px;" onclick={(e) => { 
              this.refreshAnnouncement();
            }}>
              <i className="fas fa-sync-alt"></i>
            </span>
            <span style="color:gray;cursor:pointer;font-size: 16px;padding: 0px 2px;" onclick={(e) => { 
              app.modal.show(AnnouncementManagementAddModal,{announcementData});
            }}>
              <i className="fas fa-edit"></i>
            </span>
            <span style="color:red;cursor:pointer;font-size: 16px;padding: 0px 5px;" onclick={(e) => { 
              this.updateStatus(2);
            }}>
              <i className="fas fa-minus-square"></i>
            </span>
            <span style="color:green;cursor:pointer;font-size: 16px;padding: 0px 5px;" onclick={(e) => { 
              this.updateStatus(1);
            }}>
              <i className="fas fa-check-square"></i>
            </span>
          </div>
        )}

        {announcementStatus===1 && u2diUserType9===true && (
          <div style="color:green;text-align: right;padding-top: 5px;">
            {app.translator.trans('ziven-u2di.forum.announcement-done')}
          </div>
        )}

        {announcementStatus===2 && u2diUserType9===true && (
          <div style="color:red;text-align: right;padding-top: 5px;">
            {app.translator.trans('ziven-u2di.forum.announcement-delete')}
          </div>
        )}
      </div>
    );
  }

  updateStatus(statusValue) {
    const announcementData = this.announcementData;
    app.modal.show(AnnouncementManagementUpdateModal,{announcementData,statusValue});
  }

  refreshAnnouncement() {    
    const announcementData = this.announcementData;
    app.modal.show(AnnouncementManagementRefreshModal,{announcementData})
  }
}